import { render, staticRenderFns } from "./gradingSystem.vue?vue&type=template&id=11d9968a&"
import script from "./gradingSystem.vue?vue&type=script&lang=js&"
export * from "./gradingSystem.vue?vue&type=script&lang=js&"
import style0 from "./gradingSystem.vue?vue&type=style&index=0&id=11d9968a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports